import { computed, observable } from "mobx";
import { Type } from "class-transformer";
import BankAccount from "./bankAccount";
import BankCodeType from "./bankCodeType";
import CounterpartyBankAccountResponse from "./counterpartyBankAccountResponse";
import type { IBankAccount } from "./types";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class CustomerRefundCandidateCounterpartyBankResponse {
  @observable
  @Type(() => CounterpartyBankAccountResponse)
  bankAccount?: CounterpartyBankAccountResponse;

  @observable
  name?: string;

  @observable
  cityAddress?: string;

  @observable
  countryId?: string;

  @observable
  codeType?: BankCodeType;
}

export default class CustomerRefundCandidateCounterpartyBank
  extends CustomerRefundCandidateCounterpartyBankResponse
  implements IBankAccount
{
  @computed
  get accountNumber() {
    return this.bankAccount?.accountNumber;
  }

  set accountNumber(accountNumber) {
    if (!this.bankAccount) {
      this.bankAccount = new BankAccount();
    }
    this.bankAccount.accountNumber = accountNumber;
  }

  @computed
  get bank() {
    return this.bankAccount?.bank ?? "";
  }

  set bank(bank) {
    if (!this.bankAccount) {
      this.bankAccount = new BankAccount();
    }

    this.bankAccount.bank = bank;
  }
}
